import { Component, OnInit } from '@angular/core';
import { RouteService } from 'src/app/shared/services/route.service';

export interface empresasCliente{
	cantCursos:	number;
	cantEstudiantes:	number;
	fechaCreacion:	any;
	id:	string;
	nombre:	string;
}

@Component({
  selector: 'lista-empresas-cliente',
  templateUrl: './lista-empresas-cliente.component.html',
  styleUrls: ['./lista-empresas-cliente.component.css']
})
export class ListaEmpresasClienteComponent implements OnInit {

  constructor(
    public routeService: RouteService,
  ) { }

  ngOnInit(): void {
  }

}
